var ERROR = 'Error';
var OBJECT = 'Object';
var ARRAY = 'Array';
var STRING = 'String';
var NUMBER = 'Number';
var BOOLEAN = 'Boolean';
var DATE = 'Date';
var NULL = 'Null';
var UNDEFINED = 'Undefined';
var FUNCTION = 'Function';
var SYMBOL = 'Symbol';
export default {
  ERROR: ERROR,
  OBJECT: OBJECT,
  ARRAY: ARRAY,
  STRING: STRING,
  NUMBER: NUMBER,
  BOOLEAN: BOOLEAN,
  DATE: DATE,
  NULL: NULL,
  UNDEFINED: UNDEFINED,
  FUNCTION: FUNCTION,
  SYMBOL: SYMBOL
};